import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var Heading2Svg = function Heading2Svg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.516 10.364V0H0v24h1.516V12h10.61v12h1.516V0h-1.516v10.364zM18.253 12.273c-1.151 0-2.085 1.007-2.085 2.25v1.024h1.516v-1.024c0-.34.255-.614.569-.614h3.41c.314 0 .569.275.569.613v1.587a.62.62 0 0 1-.341.562l-4.474 2.113c-.758.358-1.249 1.167-1.249 2.061v2.882H24v-1.636h-6.316v-1.246c0-.243.134-.464.34-.562L22.5 18.17c.758-.358 1.248-1.166 1.248-2.06v-1.588c0-1.243-.933-2.25-2.084-2.25z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var Heading2 = function Heading2(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: Heading2Svg
  }));
};